import { render, staticRenderFns } from "./thirdpary-new.vue?vue&type=template&id=2cb5c292&scoped=true&"
import script from "./thirdpary-new.vue?vue&type=script&lang=js&"
export * from "./thirdpary-new.vue?vue&type=script&lang=js&"
import style0 from "./thirdpary-new.vue?vue&type=style&index=0&id=2cb5c292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5c292",
  null
  
)

export default component.exports